export type UserJSON = {
	id: number;
	name: string;
	email: string;
	avatar: string;
	intercom_hash: string;
	preferences: Record<string, unknown>;
	auth_provider: string;
	is_guest: boolean;
	role: string;
	created_at: string;
	internal_usage: boolean;
	referral_source: string;
};

export type WorkspaceMemberJSON = {
	id: number;
	workspace_id: number;
	user_id: number;
	role: {
		type: string;
	};
	projects: number[];
	user_owns_a_workspace: boolean;
	owned_projects_count: number;
	is_limited_editor: boolean;
	user: UserJSON;
};

export type NonMemberRole = 'full_editor' | 'editor_expired';

export const NON_MEMBER_ROLES = {
	FULL_EDITOR: 'full_editor' as NonMemberRole,
	EDITOR_EXPIRED: 'editor_expired' as NonMemberRole
};

export type NonMemberJSON = {
	id: number;
	name: string;
	email: string;
	avatar_url: string | null;
	role: NonMemberRole;
	days_remaining: number | null;
	collaborations_count: number;
	last_active_at: string | null;
};

export type WorkspaceJSON = {
	id: number;
	name: string;
	logo: string;
};

export type AddOnPreviewJSON = {
	charged_now: number;
	recurring_amount: number;
	recurring_start_date: string | null;
	currency: string;
	is_studio_trial: boolean;
};

export type WorkspaceInvitationRole = 'WorkspaceAdmin' | 'WorkspaceCollaborator';

export type WorkspaceInvitation = {
	email: string;
	role: WorkspaceInvitationRole;
	message?: string;
};
